import { DropDown, Input } from '../components'
import { useContext, useState } from "react"
import { DataContext } from "../data/DataContext"
import { catGender } from '../data/MochaData'

const StepPersonalData2 = () => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);
    return <>
        <DropDown
            dataProvider={IHContenidoSeguroCR.catNationality}
            field='nationality'
            label='Nacionalidad'
            valueSelect={IHContenidoSeguroCR.nationality}
            onChangeSelect={ChangeHandler2}
        />
        <DropDown
            dataProvider={catGender}
            field='sex'
            label='Sexo'
            valueSelect={IHContenidoSeguroCR.sex}
            onChangeSelect={ChangeHandler2}
        />
        <DropDown
            dataProvider={IHContenidoSeguroCR.catProfession}
            field='profession'
            label='Profesión'
            valueSelect={IHContenidoSeguroCR.profession}
            onChangeSelect={ChangeHandler2}
        />
        <Input
            field='company'
            id='company'
            label='Empresa donde trabaja'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.company}
        />
        <Input
            field='companyPhone'
            id='companyPhone'
            label='Teléfono de la empresa'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.companyPhone}
            placeholder='0000-0000'
            type='mask'
            mask="9999-9999"
            title="Documento invalido"
        />
        {/* <DropDown
            dataProvider={[]}
            field=''
            label='Ocupación actual'
            valueSelect=''
            onChangeSelect={() => { }}
        /> */}

        <Input
            id='monthlyIncome'
            field='monthlyIncome'
            label='Ingreso Mensual'
            onChange={ChangeHandler2}
            value={IHContenidoSeguroCR.monthlyIncome}
            type='CURRENCY_FORMAT'
            prefix='$ '
        />
    </>
}

export { StepPersonalData2 }